import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import translate from '../../../commonComponents/translate';
import ShopProductList from './ShopSearchList';
import MarketInfosContext from '../../../contextProviders/MarketInfosContext';
import { compose } from '../../../services/utilityFunctions';
import withCSRF from '../../../commonComponents/withCSRF';

function ShopSearchContent({ t, query, isLandingPage, _csrf }) {
  const [count, setCount] = useState(0);

  const { marketInfos } = useContext(MarketInfosContext);

  const getNumberOfProducts = async () => {
    const params = {
      maxPrice: query.maxPrice,
      productType: query.productType,
      index: 0,
      offset: 1,
      country: marketInfos.localCountry,
      currency: marketInfos.localCurrency,
      language: marketInfos.localLanguage,
    };

    if (query?.category?.length > 0) {
      params.category = query.category;
    }
    if (query.search?.length > 0) {
      params.search = query.search;
    }
    if (Object.keys(query.attributes)?.length > 0) {
      params.attributes = query.attributes;
    }

    await axios
      .get('/api/market/product/list', {
        params,
        headers: {
          'Accept-Version': '1.0.0',
          'X-Gamification-API': 'Games',
          'X-CSRF-Token': _csrf,
          _csrf,
        },
      })
      .then(({ data: response }) => {
        setCount(response.total);
      })
      .catch(err => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (!isLandingPage) {
      getNumberOfProducts();
    }
  }, [query]);

  return (
    <div>
      {!isLandingPage && (
        <div className="row mb-4">
          <div className="col-12">
            <span className="shopQueryResults">
              {count} {t('shop.product.results')}
            </span>
          </div>
        </div>
      )}
      <div className="m-portlet__body m--padding-top-5 m--padding-bottom-20 shop-search-content">
        <div className="row">
          <div className="col-lg-12 shop-search-content-items">
            <ShopProductList
              t={t}
              query={query}
              marketInfos={marketInfos}
              isLandingPage={isLandingPage}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

ShopSearchContent.propTypes = {
  t: PropTypes.func.isRequired,
  query: PropTypes.shape({
    category: PropTypes.string.isRequired,
    maxPrice: PropTypes.number.isRequired,
    search: PropTypes.string.isRequired,
    attributes: PropTypes.shape({}).isRequired,
    productType: PropTypes.string,
  }).isRequired,
  isLandingPage: PropTypes.bool,
  _csrf: PropTypes.string.isRequired,
};

ShopSearchContent.defaultProps = {
  isLandingPage: false,
};

export default compose(translate, withCSRF)(ShopSearchContent);
